
  export const transMethods = ['Trains', 'Trirail', 'Bus'];